const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/InvoiceCard/InvoiceCard.tsx';
import React from 'react';
import textMap from 'App/pages/DashboardPage/translations';
import { useHistory } from 'react-router';
import { goToInvoices } from 'App/utils/history';
import { DashboardCard } from '../DashboardCard';
import { CardNavigationLink } from '../CardNavigationLink';
import { useInvoices } from 'App/store/documents';

export const InvoiceCard = (props: any) => {
    const history = useHistory();
    const { data: invoices, isPendingOrLoading: isDataLoading } = useInvoices();
    const hasData = !!invoices?.length;

    const handleClick = () => goToInvoices(history);

    return (
        <DashboardCard
            iconClass="icons8-document"
            onClick={handleClick}
            isDataLoading={isDataLoading}
            hasData={hasData}
        >
            <CardNavigationLink text={textMap.InvoicesBtn} />
        </DashboardCard>
    );
};

export default InvoiceCard;
